"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = useMarketo;
const react_1 = require("react");
function useMarketo({ baseUrl, munchkinId, formId, callback, }) {
    const [scriptLoaded, setScriptLoaded] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (scriptLoaded) {
            // @ts-ignore
            window.MktoForms2.loadForm(baseUrl, munchkinId, formId, callback);
        }
        loadScript(baseUrl, setScriptLoaded);
    }, [scriptLoaded]);
}
function loadScript(baseUrl, setScriptLoaded) {
    // @ts-ignore
    if (window.MktoForms2)
        return setScriptLoaded(true);
    const script = document.createElement('script');
    script.src = `${baseUrl}/js/forms2/js/forms2.min.js`;
    // @ts-ignore
    script.onload = () => (window.MktoForms2 ? setScriptLoaded(true) : null);
    document.body.appendChild(script);
}
